<template>
    <v-container grid-list-lg style="max-width: 1240px" class="py-3 px-0 osago-dcard">
        <v-layout>
            <v-flex pb-2>
                <h3 style="display:inline; margin-right: 5px">Диагностическая карта
                    <v-progress-circular
                        v-if="dcardInfoLoading"
                        class="ml-1"
                        indeterminate
                        color="#00ba57"
                        size="10"
                        width="2"
                    />
                </h3>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm6 md4 py-0>
                <div v-if="showDcardInfoLoader" class="pt-1">
                    <a  :class="(loadingDcard || (!vin && !licensePlate)) ? 'policy-disabled' : 'policy'"
                        style="text-decoration: underline"
                        @click="getDcard(vin, licensePlate)"
                    >
                        Получить диагностическую карту
                    </a>
                    <v-progress-circular
                        v-if="loadingDcard || dcardInfoLoading"
                        class="ml-1"
                        indeterminate
                        color="#00ba57"
                        size="10"
                        width="2"
                    />
                </div>
                <v-text-field
                        v-model="value.seriesNumber"
                        mask="###############"
                        return-masked-value
                        label="Номер диагностической карты"
                        :rules="[dcardRules]"
                        validate-on-blur
                        :disabled="disabled || dcardInfoLoading || loadingDcard"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 py-0
                    style="align-self: flex-end;"
            >
                <osago-date
                    v-model="value.endDate"
                    :isRequired="!!b2b && !!value.seriesNumber"
                    label="Дата окончания"
                    :min="getMinDate()"
                    :max="getMaxDate()"
                    :is-disabled="disabled || dcardInfoLoading || loadingDcard"
                    :isHideMobile="true"
                />
            </v-flex>
            <v-flex xs12 md8 py-0 v-if="dcardInfoLoading || loadingDcard">
                <p class="alert-text">
                    Мы ищем Вашу диагностическую карту
                </p>
            </v-flex>
            <v-flex xs12 md8 py-0 v-if="value.alertText && !dcardInfoLoading && !loadingDcard">
                <p :class="value.alertColor ? 'alert-text text-' + value.alertColor : 'alert-text'">{{value.alertText}}</p>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import moment from "moment";
    export default {
        name: "ToDoc",

        props: [
            'value',
            'showTo',
            'disabled',
            'showDcardInfoLoader',
            'vin',
            'licensePlate',
            'dcardInfoLoading',
            'b2b'
        ],

        data: () => ({
            loadingDcard: false,
            clarificationText: null,
            clarificationColorClass: null
        }),
        computed: {
            getText: () => {
                if (!this.value) {
                    return 'no value'
                }
                return this.value.seriesNumber
            },
        },
        methods: {
            dcardRules(value) {
                if (value != null) {
                    if (value.length == 0) {
                        return true
                    }
                    return /^\d{15}$/.test(value) || 'Неверный формат'
                }
                return true
            },
            noToChanged(noTo) {
                this.value.seriesNumber = noTo ? '' : this.value.seriesNumber;
                this.value.endDate = noTo ? null : this.value.endDate;
            },
            getMinDate() {
                // для диагностической карты дата окончания не может быть в прошлом
                const date = new Date();
                // yyyy-mm-dd
                return date.getFullYear() + '-' +
                    this.getZeroDate(date.getMonth() + 1) + '-' +
                    this.getZeroDate(date.getDate());
            },
            getMaxDate() {
                // для диагностической карты максимальная дата окончания: сегодняшний день + 2 года
                const date = new Date();
                // yyyy-mm-dd
                return (date.getFullYear() + 2) + '-' +
                    this.getZeroDate(date.getMonth() + 1) + '-' +
                    this.getZeroDate(date.getDate() + 1);
            },
            getZeroDate(date) {
                return date < 10 ? date = '0' + date : date;
            },
            getDcard(vin, licensePlate) {
                if (!vin && !licensePlate) {
                    PNotify.error('Невозможно получить данные диагностической карты');
                    return;
                }
                const url = vin ? '/info/dcard?vin=' + vin : '/info/dcard?regNumber=' + licensePlate;
                let that = this;
                this.dcardInfoLoading = this.loadingDcard = this.disabled = true;
                axios.get(url).then((result) => {
                    if (result.data.response && result.data.status === 'ok') {
                        const info = result.data.response;
                        if (info.dcard) {
                            that.value.seriesNumber = info.dcard;
                        }
                        if (info.dcardEndDate) {
                            that.value.endDate = this.checkForTempLow(info.dcardEndDate);
                        }
                    } else {
                        if (vin && result.data.status === 'error' && licensePlate) {
                            this.getDcard(null, licensePlate);
                            return;
                        }
                        console.log('Dcard info response:', result);
                        PNotify.error('Не удалось получить данные диагностической карты');
                    }
                }).catch((error) => {
                    console.log('Error: ', error);
                    PNotify.error('Не удалось получить данные диагностической карты');
                }).finally(() => {
                    this.dcardInfoLoading = this.loadingDcard = this.disabled = false;
                    this.$emit('dcardLoaded');
                });
            },

            checkForTempLow(dcardEndDate) {
                let date = moment(dcardEndDate)

                let dateMinFirst = moment('2021-02-01')
                let dateMaxFirst = moment('2021-04-01')

                let dateMinSecond = moment('2021-04-02')
                let dateMaxSecond = moment('2021-09-30')

                if (date.isSameOrBefore(dateMaxFirst, 'day') && date.isSameOrAfter(dateMinFirst, 'day')) {
                    dcardEndDate = '2021-10-01'
                }
                if (date.isSameOrBefore(dateMaxSecond, 'day') && date.isSameOrAfter(dateMinSecond, 'day')) {
                    dcardEndDate = date.add(6, 'months').format('YYYY-MM-DD')
                }
                return dcardEndDate
            },
        }
    }
</script>

<style scoped>
a.policy {
    color: #00ba57;
}

a.policy-disabled {
    color: #858585;
}

p.text-black {
    color: #000000;
}

p.text-red {
    color: #ff5252;
}

p.text-yellow {
    color: #b7b708;
}

p.text-green {
    color: #00ba57;
}

p.alert-text {
    white-space: pre-wrap;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/fields/ToDoc.vue